attachEvent('.menu__arrow', 'click', (ev) => {
  if (windowWidth() >= breakpointMd) {
    return;
  }

  const parent = ev.target.closest('.menu__item');
  parent.classList.toggle('is-open-submenu');
  const dropdown = parent.querySelector('.mega-menu');
  slideToggle(dropdown, 300, 'block');
});
